import { FaIcon, FaIconProps } from '@acp/core-ui';
import { AccessIssueSolutionLabel } from '@acp/shared';
import {
    faAt,
    faCalendarDay,
    faEnvelopeDot, faHouse, faHousePersonReturn, faHouseUser, faKey,
    faPhone,
} from '@fortawesome/pro-light-svg-icons';

export function SolutionIcon({
    solutionLabel,
    ...props
}: {
    solutionLabel: AccessIssueSolutionLabel;
} & Omit<FaIconProps, 'icon'>) {
    switch (solutionLabel) {
        case AccessIssueSolutionLabel.VerifyGoodKey:
        case AccessIssueSolutionLabel.VerifyKeyOnsite:
            return <FaIcon {...props} icon={faKey} />;
        case AccessIssueSolutionLabel.AddEmail:
        case AccessIssueSolutionLabel.AgencyEmail:
        case AccessIssueSolutionLabel.AgencyEmailToOwnersCorpAccessInstructions:
            return <FaIcon {...props} icon={faEnvelopeDot} />;
        case AccessIssueSolutionLabel.SpeakWithTenant:
            return <FaIcon {...props} icon={faPhone} />;
        case AccessIssueSolutionLabel.AddTenantDetails:
        case AccessIssueSolutionLabel.UpdateTenantDetails:
        case AccessIssueSolutionLabel.ConfirmTenantDetails:
            return <FaIcon {...props} icon={faHouseUser} />;
        case AccessIssueSolutionLabel.ProvideAccessInstructions:
        case AccessIssueSolutionLabel.ProvideInstructionsToBypassHomeSecurity:
            return <FaIcon {...props} icon={faAt} />;
        case AccessIssueSolutionLabel.ManuallyBookInJobForTenant:
            return <FaIcon {...props} icon={faCalendarDay} />;
        case AccessIssueSolutionLabel.AllowAllFormsOfEntry:
            return <FaIcon {...props} icon={faHousePersonReturn} />;
        default:
            return <FaIcon {...props} icon={faHouse} />;
    }
}
